import request from '@/utils/request'

// 查询服务分页
export function pageService(data) {
  return request({
    url: '/homeservice/service/page',
    method: 'post',
    data: data
  })
}

// 查询服务详情
export function getService(data) {
  return request({
    url: '/homeservice/service/detail',
    method: 'get',
    params: data
  })
}

// 新增服务
export function addService(data) {
  return request({
    url: '/homeservice/service/add',
    method: 'post',
    data: data
  })
}

// 修改服务
export function updateService(data) {
  return request({
    url: '/homeservice/service/edit',
    method: 'post',
    data: data
  })
}

// 删除服务
export function delService(data) {
  return request({
    url: '/homeservice/service/delete',
    method: 'post',
    data: data
  })
}

// 查询服务分类列表
export function listCategory(data) {
  return request({
    url: '/homeservice/category/list',
    method: 'get',
    params: data
  })
}

// 查询中国所有市级城市列表
export function listChinaCity() {
  return request({
    url: '/sys/area/cityList',
    method: 'get'
  })
}
